// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--WIVAY","wrapper":"_93444fe79c--wrapper--yTRAb","title":"_93444fe79c--title--eBhDq","description":"_93444fe79c--description--b9HhY"};